import React, {Component} from 'react';
//import {useQuery, useApolloClient, useSubscription} from '@apollo/react-hooks';
//import gql from 'graphql-tag';

import {eightEorzianHours, BELL_COUNT, weatherFinder, timeUtils} from "../../utils/timeUltils.js";

import '../../gamedata/spritesheet/achievement.css';
import auth0 from "../../auth0";
let urlify = require('urlify').create();

let rewardTiers = ['Bronze', 'Silver', 'Gold'];
let classes = ['Carpenter', 'Blacksmith', 'Armorer', 'Goldsmith', 'Leatherworker', 'Weaver', 'Alchemist', 'Culinarian', 'Miner', 'Botanist', 'Fisher'];
let typeSort = ['critical', 'sequential', 'time', 'weather', 'a', 'b', 'c', 'd'];
let readableTypes = {
	critical: 'Critical',
	sequential: 'Sequential',
	time: 'Time-restricted',
	weather: 'Weather-restricted',
	a: 'Class A',
	b: 'Class B',
	c: 'Class C',
	d: 'Class D',
}

//let dataCenters = require('../../gamedata/json/dataCenters.json');
//let missions = require('../../gamedata/json/en/cosmicMissions.json');
//let missionText = require('../../gamedata/json/en/cosmicMissionText.json');
//let points = require('../../data/cosmicPoints').default;

let userStore = require('../../stores/user').default;
let charStore = require('../../stores/char').default;
let store = require('../../stores/gameData').default;

/*export default function CharAchievementsRoute({url, lang}) {
	let achievementKindsQuery = gql`
subscription {
  achievementKinds {
    id
    name:name_en
    achievementCategories {
      id
      name:name_en
    }
  }
}
`;
	let achievementsQuery = gql`
subscription {
  achievements {
    id
    name:name_en
    obtainable
    icon
    points
    description:description_en
    sortIndex:sort
    notLegacy
    item {
      id
      name:name_en
    }
    title:titleRef {
      id
      name:feminine_en
    }
    achievementCategoryId
  }
}
`;
	let characterQuery = gql`
subscription characters($characterId:Int!) {
  characters_by_pk(id: $characterId) {
    id
    achievements {
      createdAt
      achievementId
    }
  }
}
`;
	let achievementKindsResult = useSubscription(achievementKindsQuery);
	let achievementsResult = useSubscription(achievementsQuery);
	let characterResult = useSubscription(characterQuery, {
		variables: {characterId:url[1]}
	});
	/*const {data, error, loading} = useQuery(QUERY, {
		variables: {characterId:url[1]}
	});* /
	if (achievementKindsResult.loading || achievementsResult.loading || characterResult.loading) {
		return <div className="LoadingOverlay LoadingOverlay-Visible">Loading...</div>
	}
	if (achievementKindsResult.error || achievementsResult.error || characterResult.error) {
		return <div>Error.</div>
	}
	let char = characterResult.data.characters_by_pk;
	let achievements = achievementsResult.data.achievements;
	let achievementKinds = achievementKindsResult.data.achievementKinds;
	/*return <CharAchievementsRouteInner lang={lang} char={data.characters_by_pk} achievements={data.achievements} achievementKinds={data.achievementKinds} url={url} />;
}*/

export default class CharCosmicRoute extends Component {
	state = {
		char: charStore.getData(),
		jobs: store.get('jobs', 'en'),
		achievements: store.get('achievements'),
		achievementCategories: store.get('achievementCategories'),
		titles: store.get('titles'),
		items: store.get('items'),
		rarity: store.getRarity('achievements'),
		rewardTier: 'Bronze',
		sort: 'In-Game',
		loaded: false,
		missions: [],
		missionText: [],
		redAlerts: [],
		development: {},
		points: {},
		jobsByTime: {},
		jobsByWeather: {},
		currentTime: timeUtils.calculateCurrentEorziaTime(),
	};

	constructor(props) {
		super(props);
		charStore.on(this.onChange, this);
		store.on(this.onChange, this);
		this.onChange = this.onChange.bind(this);
		this.setSort = this.setSort.bind(this);
		this.onRewardTierClick = this.onRewardTierClick.bind(this);

	}
	componentDidUpdate(prevProps) {
		if (prevProps.lang !== this.props.lang) {
			this.componentDidMount();
		}
	}

	componentDidMount() {
		this.setState({
			timer: setInterval(() => {
				this.setState({currentTime: timeUtils.calculateCurrentEorziaTime()})
			}, 3*1000)
		});
		let promise;
		if (this.props.lang === 'fr') {
			promise = import(/* webpackChunkName: "cosmic-fr" */ './cosmicData/fr');
		} else if (this.props.lang === 'ja') {
			promise = import(/* webpackChunkName: "cosmic-ja" */ './cosmicData/ja');
		} else if (this.props.lang === 'de') {
			promise = import(/* webpackChunkName: "cosmic-de" */ './cosmicData/de');
		} else {
			promise = import(/* webpackChunkName: "cosmic-en" */ './cosmicData/en');
		}
		promise.then(data => {
			let jobsByTime = {};
			let jobsByWeather = {};
			data.missions.forEach(mission => {
				if (mission.type === 'critical') {
					let ra = data.redAlerts.find(ra => ra.missions.indexOf(mission.id) > -1);
					if (ra) mission.redAlert = ra;
				}
				if (mission.type === 'time') {
					if (!jobsByTime[mission.startHour]) jobsByTime[mission.startHour] = [];
					if (mission.classes[0] > 0) jobsByTime[mission.startHour].push([mission.classes[0], data.points[mission.id] > 0 || data.development[mission.id]]);
					if (mission.classes[1] > 0) jobsByTime[mission.startHour].push([mission.classes[1], data.points[mission.id] > 0 || data.development[mission.id]]);
				}
				if (mission.type === 'weather') {
					if (!jobsByWeather[mission.weather]) jobsByWeather[mission.weather] = [];
					if (mission.classes[0] > 0) jobsByWeather[mission.weather].push([mission.classes[0], data.points[mission.id] > 0]);
					if (mission.classes[1] > 0) jobsByWeather[mission.weather].push([mission.classes[1], data.points[mission.id] > 0]);
				}
				if (data.requirements[mission.id]) {
					mission.requirements = data.requirements[mission.id];
				}
			})
			this.setState({
				loaded: true,
				missions: data.missions,
				missionText: data.missionText,
				points: data.points,
				development: data.development,
				redAlerts: data.redAlerts,
				jobsByTime: jobsByTime,
				jobsByWeather: jobsByWeather,
			});
		}).catch(err => {
			console.error(err);
		});
	}
	componentWillUnmount() {
		charStore.off(this.onChange, this);
		store.off(this.onChange, this);
		clearInterval(this.state.timer);
	}

	onChange() {
		this.setState({
			char: charStore.getData(),
			achievements: store.get('achievements'),
			achievementCategories: store.get('achievementCategories'),
			titles: store.get('titles'),
			items: store.get('items'),
			rarity: store.getRarity('achievements')
		});
	}
	onRewardTierClick(e) {
		this.setState({rewardTier: e.target.innerText});
	}
	setSort(e) {
		this.setState({
			sort: e.target.innerHTML
		});
	}
	showLoginMessage() {
		alert('Please log in and verify ownership of this character to check off items.');
	}
	toggleItem(id, toggleTo) {
		if (toggleTo) {
			charStore.markItem('cosmicMission', id);
		} else {
			charStore.unmarkItem('cosmicMission', id);
		}
	}
	render() {
		let char = this.props.char, lang = this.props.lang, urlBase = this.props.urlBase;//, achievements = this.props.achievements, achievementKinds = this.props.achievementKinds;
		//let obtained = [], extra = [], remaining = [], unobtainable = [];*/
		let currentCategorySlug = this.props.url[0], currentCategory;
		let user = auth0.getUser();

		let achievements = this.state.achievements;
		let achievementCategories = this.state.achievementCategories;
		let titles = this.state.titles;
		let items = this.state.items;
		let rarity = this.state.rarity;
		let missions = this.state.missions;
		let missionText = this.state.missionText;
		let points = this.state.points;
		let development = this.state.development;

		let isCharMine = userStore.getUserChars().find(c => c.id === char.id);


		var currentTime = this.state.currentTime; //timeUtils.calculateCurrentEorziaTime();
		//console.log('currentTime', currentTime);
		var weatherStartTime = timeUtils.calculateCurrentWeatherTimeFloor();
		var weatherStartHour = timeUtils.calculateEorziaTime(weatherStartTime)[0];
		let icons = {
			'Umbral Wind': '060219', //<img src="/gamedata/ui_webp/060000/060219.webp?c=1" width="32" height="32" />,
			'Moon Dust': '060222', //<img src="/gamedata/ui_webp/060000/060222.webp?c=1" width="32" height="32" />,
			'Fair Skies': '060202', //<img src="/gamedata/ui_webp/060000/060202.webp?c=1" width="32" height="32" />
		};

		let weatherRows = [];
		let currentWeatherName = weatherFinder.getWeather(new Date(weatherStartTime), 'Sinus Ardorum');
		let nextUmbralWind, nextMoonDust, currentWeather;
		let i = 1;
		while (!nextUmbralWind || !nextMoonDust) {
			var realDate = new Date(weatherStartTime + i*eightEorzianHours);
			let weather = weatherFinder.getWeather(realDate, 'Sinus Ardorum');
			if (!nextUmbralWind && weather === 'Umbral Wind') {
				nextUmbralWind = <div>{timeUtils.toLocaleString(realDate)}<br /><span className="RelativeTime">({timeUtils.getRelativeTimeString(realDate)})</span></div>;
			}
			if (!nextMoonDust && weather === 'Moon Dust') {
				nextMoonDust = <div>{timeUtils.toLocaleString(realDate)}<br /><span className="RelativeTime">({timeUtils.getRelativeTimeString(realDate)})</span></div>;
			}
			if (!currentWeather && (currentWeatherName !== weather)) {
				currentWeather = <div><img src={`/gamedata/ui_webp/060000/${icons[currentWeatherName]}.webp?c=1`} width="32" height="32" /> {currentWeatherName}<br /><span className="RelativeTime">(ends {timeUtils.getRelativeTimeString(realDate)})</span></div>;
			}
			i++;
		}
		for (let i = 0; i < 60; i++) {
			var hour = (weatherStartHour + i*8) % 24;
			var hourString;
			if (hour >= 12) {
				hourString = (hour - 12) + 'p';
			} else if (hour >= 1) {
				hourString = hour + 'a';
			} else if (hour === 0) {
				hourString = '12a';
			} else {
				hourString = hour + '?';
			}
			var realDate = new Date(weatherStartTime + i*eightEorzianHours);
			let weather = weatherFinder.getWeather(realDate, 'Sinus Ardorum');
			let timeString = realDate.toLocaleTimeString('en-US', {
				//month: false,
				//day: 'numeric',
				hour: 'numeric',
				minute: '2-digit'
			});
			weatherRows.push(<span className="WeatherTime" key={i}><img key={i} src={`/gamedata/ui_webp/060000/${icons[weather]}.webp?c=1`} width="32" height="32" alt={timeString} title={timeString} /><span>{timeString}</span></span>)
		}

		let loading;
		if (!this.state.loaded) {
			loading = <p>Loading...</p>;
		}

		let rewardTierFilters = rewardTiers.map(tier => {
			return <button onClick={this.onRewardTierClick} className={this.state.rewardTier===tier?'current':''} key={tier}>
				{tier}
			</button>;
		});

		let currentJobSlug = this.props.url[0];
		let currentMissionId = this.props.url[1]*1;
		let currentType;
		if (currentJobSlug === 'critical') {
			currentType = {
				Id: 0,
				Name: 'Critical',
			}
		} else {
			currentType = this.state.jobs.find(type => type.Name.length > 0 && type.Name === currentJobSlug);
		}
		if (!currentType) currentType = this.state.jobs.find(type => type.Name === 'carpenter');

		/*console.log('missions', missions);
		console.log('currentType', currentType);
		console.log('points', points);*/

		let filters = classes.map(type1 => {
			let type = this.state.jobs.find(type => type.Name === type1.toLowerCase());
			let hasCount = 0, totalCount = 0;
			missionRows = missions.filter(mission => {
				return mission.classes.includes(type.Id);
			}).forEach(mission => {
				let has = char.id > 0 && charStore.hasItem('cosmicMission', mission.id);
				if (has) hasCount++;
				totalCount++;
			});
			/*this.state.leves.filter(leve => {
				return leve.leveAssignmentTypeId === type.id;
			}).forEach(leve => {
				//let has = this.state.char && this.state.char.leve && this.state.char.leve.find(l => l.leveId === leve.Id && l.deleted !== true);
				if (!leve.isRemoved && !leve.isUnlock) {
					let has = char.id > 0 && charStore.hasItem('leve', leve.id);
					if (has) hasCount++;
					totalCount++;
				}
			});*/
			let percent = hasCount * 100 / totalCount;
			let className = 'FilterProgressInner';
			if (percent >= 100) {
				className += ' FilterProgressInner-Complete';
			}
			return <a href={`${urlBase}cosmic/${type.Name}`} className={currentType?.Id===type.Id?'current':''} key={type.Id}>
				<i className={`icon icon-leveAssignmentType icon-leveAssignmentType-${type.Name[0].toUpperCase()}${type.Name.substring(1)}`} />
				<span className="FilterProgressContainer"><span className={className} style={{width:percent+'%'}}>&nbsp;</span></span>
			</a>;
		});
		(() => {
			let hasCount = 0, totalCount = 0;
			missionRows = missions.filter(mission => {
				return mission.type === 'critical';
			}).forEach(mission => {
				let has = char.id > 0 && charStore.hasItem('cosmicMission', mission.id);
				if (has) hasCount++;
				totalCount++;
			});
			let percent = hasCount * 100 / totalCount;
			let className = 'FilterProgressInner';
			if (percent >= 100) {
				className += ' FilterProgressInner-Complete';
			}
			filters.unshift(<a href={`${urlBase}cosmic/critical`} className={currentJobSlug==='critical'?'current':''} key={'critical'}>
				Red Alerts
				<span className="FilterProgressContainer"><span className={className} style={{width:percent+'%'}}>&nbsp;</span></span>
			</a>);
		})()


		let missionRows = [];
		let filteredMissions = missions.filter(mission => {
			if (currentJobSlug==='critical') {
				return mission.type === 'critical';
			} else {
				return mission.classes.includes(currentType.Id);
			}
		}).sort((a, b) => {
			if (currentJobSlug === 'critical') {
				if (a.redAlert.id > b.redAlert.id) return 1;
				if (a.redAlert.id < b.redAlert.id) return -1;
			}
			if (typeSort.indexOf(a.type) > typeSort.indexOf(b.type)) return 1;
			if (typeSort.indexOf(a.type) < typeSort.indexOf(b.type)) return -1;
			if (a.sort > b.sort) return 1;
			if (a.sort < b.sort) return -1;
			if (a.sort1 > b.sort1) return 1;
			if (a.sort1 < b.sort1) return -1;
			if (a.Id > b.Id) return 1;
			if (a.Id < b.Id) return -1;
			return 0;
		});
		filteredMissions.forEach((mission, i) => {
			let className = 'MountRow';
			let url = `${urlBase}cosmic/${currentType.Name}/${mission.id}/`;

			let checkbox;
			let has = char.id > 0 && charStore.hasItem('cosmicMission', mission.id);
			if (has) {
				className += ' MountRow-Have';
			}
			if (isCharMine) {
				checkbox = <button onClick={(e) => this.toggleItem(mission.id, !has)}>
					<i className={this.state.char.char.cosmicMissionload && this.state.char.char.cosmicMissionload.includes(mission.id) ? 'fontello-spin1 animate-spin' : 'fontello-ok'}/>
				</button>;
			} else {
				checkbox = <i className={'fontello-ok'} onClick={this.showLoginMessage}/>;
			}

			let multiplier = 1;
			if (this.state.rewardTier === 'Gold' && mission.type !== 'critical') {
				multiplier = 5;
			} else if (this.state.rewardTier === 'Silver' && mission.type !== 'critical') {
				multiplier = 4;
			} else {
				multiplier = 1;
			}

			let recipes = [];
			mission.recipes.forEach(recipe => {
				var dir = recipe.icon.slice(0, 3) + '000';
				recipes.push(<div key={recipes.length}><img src={`/gamedata/ui_webp/${dir}/${recipe.icon}.webp?c=1`} height="24" width="24" /> {recipe.name}</div>)
			});

			let rewards = [];
			let rewardKeys = [];
			if (points[mission.id]) {
				//rewards.push(<span><i className="fontello-achievement" />{points[mission.id]}</span>);
			} else {
				//rewards.push(<span><i className="fontello-achievement" />?</span>);
			}
			//rewards.push(<span><img src={`/gamedata/ui_webp/065000/065112.webp?c=1`} height="24" width="24" />{mission.reward.Cosmocredit}</span>);
			//rewards.push(<span><img src={`/gamedata/ui_webp/065000/065126.webp?c=1`} height="24" width="24" />{mission.reward.LunarCredit}</span>);
			let expIconBase = 70801;
			mission.classes.forEach(jobId => {
				for (let i = 1; i <= 3; i++) {
					if (mission.reward['ExpGrade'+i] > 0 && !rewardKeys[jobId + '-' + mission.reward['ExpGrade'+i]]) {
						rewardKeys[jobId + '-' + mission.reward['ExpGrade'+i]] = mission.reward['ExpQty'+i];
						let icon = ('000000' + (expIconBase + (mission.reward['ExpGrade'+i]*11-11) + (jobId - 8))).slice(-6);
						var dir = icon.slice(0, 3) + '000';
						rewards.push(<span key={jobId + '-' + i}><img src={`/gamedata/ui_webp/${dir}/${icon}.webp?c=1`} height="24" width="24" />{mission.reward['ExpQty'+i] * multiplier}</span>);
					}
				}
			})

			if (currentJobSlug === 'critical') {
				if (mission.redAlert !== filteredMissions[i-1]?.redAlert) {
					missionRows.push(<tr key={mission.redAlert.id + 'v' + mission.redAlert.variant}><td colSpan={4}>
						<h3>{mission.redAlert.name} (v{mission.redAlert.variant})</h3>
						<p dangerouslySetInnerHTML={{__html:'&ldquo;'+mission.redAlert.balloons.join('<br />')+'&rdquo;'}} />
					</td></tr>);
					/*if (mission.type === 'sequential' && (currentType.Name === 'miner' || currentType.Name === 'botanist')) {
						missionRows.push(<tr><td colSpan={4}><i className="fontello-attention" /> MIN/BTN sequential missions are not listed in the same order as in-game and chains may be incorrect.</td></tr>);
					}*/
				}

			} else {
				if (mission.type !== filteredMissions[i-1]?.type) {
					missionRows.push(<tr key={mission.type}><td colSpan={4}><h3>{readableTypes[mission.type]}</h3></td></tr>);
					/*if (mission.type === 'sequential' && (currentType.Name === 'miner' || currentType.Name === 'botanist')) {
						missionRows.push(<tr><td colSpan={4}><i className="fontello-attention" /> MIN/BTN sequential missions are not listed in the same order as in-game and chains may be incorrect.</td></tr>);
					}*/
				}
			}
			let requireText, unlockText;
			if (mission.type === 'sequential') {
				let requires = missions.find(m => m.id === mission.previousMissionId);
				requireText = <div>{requires.name} <i className="fontello-right-open" /></div>;
			}
			let unlocks = missions.find(m => mission.id === m.previousMissionId);
			if (unlocks) {
				unlockText = <div><i className="fontello-right-open" /> {unlocks.name}</div>;
			}
			let ra;
			if (mission.type === 'critical' && currentJobSlug !== 'critical') {
				//let raName = this.state.redAlerts.find(ra => ra.missions.indexOf(mission.id) > -1);
				ra = <div className="MountMinionDetails-Tag PinkTag">{mission.redAlert.name} (v{mission.redAlert.variant})</div>;
			}
			let requirements;
			if (mission.requirements) {
				let requiredMissions = mission.requirements.map(requirement => {
					let requiredMission = missions.find(m => m.id === requirement);
					return <div key={requirement}><i className={`icon icon-leveAssignmentType smallicon icon-leveAssignmentType-${classes[requiredMission.classes[0] - 8]}`}/> {requiredMission.name}</div>;
				});
				requirements = <div>
					<div className="OrangeTag">Requires:</div>
					{requiredMissions}
				</div>
			}
			let time;
			if (mission.type === 'time') {
				time = <span><i className="fontello-clock" /> {mission.startHour}:00 - {mission.endHour-1}:59</span>;
			}
			if (mission.type === 'weather') {
				let weather = {49: 'Umbral Wind', 148: 'Moon Dust'}[mission.weather];
				time = <span><img src={`/gamedata/ui_webp/060000/${icons[weather]}.webp?c=1`} height="24" width="24" /> {weather}</span>;
			}
			let styles= {};
			let idText;
			if (user && (user['https://lalachievements.com/api/roles'].indexOf('admin') > -1 || user['https://lalachievements.com/api/roles'].indexOf('debug') > -1)) {
				idText = ` [${mission.id}]`;
			}
			let developmentFlag;
			if (development[mission.id]) {
				developmentFlag = <div className="MountMinionDetails-Tag OrangeTag">Development Log {development[mission.id]}</div>;
			} else if (!(points[mission.id] > 0)) {
				styles.opacity = 0.3;
				developmentFlag = <div className="MountMinionDetails-Tag UnobtainableTag">Not Yet Available</div>;
			}
			let jobIcon;
			if (currentJobSlug === 'critical') {
				jobIcon = <td className="MountRow-Icon">
					<i className={`icon icon-leveAssignmentType icon-leveAssignmentType-${classes[mission.classes[0] - 8]}`}/>
				</td>;
			}

			missionRows.push(<tr className={className} style={styles} key={mission.id}>
				<td className="MountRow-Check">
					{checkbox}
				</td>
				{jobIcon}
				<td className="MountRow-Text">
					{requireText}
					<span href={url} className="MountRow-Name">{mission.name}</span>{idText}
					{ra}
					{developmentFlag}
					{requirements}
					{unlockText}
				</td>
				<td className="MountRow-Text">
					{time}
				</td>
				<td className="MountRow-Text notMobile">
					<div><img src={`/gamedata/ui_webp/065000/065112.webp?c=1`} height="24" width="24" />{mission.reward.Cosmocredit * multiplier}</div>
					<div><img src={`/gamedata/ui_webp/065000/065126.webp?c=1`} height="24" width="24" />{mission.reward.LunarCredit * multiplier}</div>
				</td>
				<td className="MountRow-Text notMobile">
					<div><i className="fontello-achievement" />{points[mission.id] > 0 ? points[mission.id] * multiplier : '?'}</div>
					<div>{rewards}</div>
				</td>
				{ /*<td className="MountRow-Text notMobile">
					{recipes}
				</td>*/ }
			</tr>);
			//return <div><pre>{JSON.stringify(mission, null, 2)}</pre></div>
		});

		let timeData = [];
		timeData.push(currentTime[0] % 2 > 0 ? currentTime[0] - 1 : currentTime[0]);
		for (let i = 1; i < 6; i++) {
			timeData.push(timeData[0] + (i*2));
		}
		let timeRows = timeData.map((hour, i) => {
			if (hour > 23) hour = hour - 24;
			let jobs = this.state.jobsByTime[hour]?.map(timeJob => {
				let job = this.state.jobs.find(j => j.Id === timeJob[0]);
				return <i key={job.Id} className={`icon smallicon icon-leveAssignmentType icon-leveAssignmentType-${job.Name[0].toUpperCase()}${job.Name.substring(1)}`} style={timeJob[1] ? {} : {opacity: 0.3}} />;
				//return job.Name;
			});
			let timeString = i > 0 ? `${hour}:00` : `${currentTime[0]}:${('00'+currentTime[1]).slice(-2)}`;
			return <div key={hour}>{timeString} {jobs}</div>;
		});

		return <div>
			<div className="CosmicHeader">
				<div>
					<div><h3>Current Weather</h3>{currentWeather}</div>
					{ /*<div><h3>Next <img src={`/gamedata/ui_webp/060000/${icons['Moon Dust']}.webp?c=1`} alt="Moon Dust" width="32" height="32" /> <i className={`icon smallicon icon-leveAssignmentType icon-leveAssignmentType-Blacksmith`} /><i className={`icon smallicon icon-leveAssignmentType icon-leveAssignmentType-Armorer`} /><i className={`icon smallicon icon-leveAssignmentType icon-leveAssignmentType-Goldsmith`} /><i className={`icon smallicon icon-leveAssignmentType icon-leveAssignmentType-Alchemist`} /><i className={`icon smallicon icon-leveAssignmentType icon-leveAssignmentType-Culinarian`} /></h3>{nextMoonDust}</div>
					<div><h3>Next <img src={`/gamedata/ui_webp/060000/${icons['Umbral Wind']}.webp?c=1`} alt="Umbral Wind" width="32" height="32" /> <i className={`icon smallicon icon-leveAssignmentType icon-leveAssignmentType-Carpenter`} /><i className={`icon smallicon icon-leveAssignmentType icon-leveAssignmentType-Leatherworker`} /><i className={`icon smallicon icon-leveAssignmentType icon-leveAssignmentType-Weaver`} /></h3>{nextUmbralWind}</div>*/ }
					<div><h3>Next <img src={`/gamedata/ui_webp/060000/${icons['Moon Dust']}.webp?c=1`} alt="Moon Dust" width="32" height="32" /></h3>{nextMoonDust}</div>
					<div><h3>Next <img src={`/gamedata/ui_webp/060000/${icons['Umbral Wind']}.webp?c=1`} alt="Umbral Wind" width="32" height="32" /></h3>{nextUmbralWind}</div>
					<div><h3>Current Time</h3>{timeRows[0]}</div>
				</div>

				<div className="WeatherTimeList">
					{weatherRows}
				</div>

				<div className="TimeTimeList">
					{ /*<h3>Current Time</h3>
					<div>{currentTime[0]}:{('00'+currentTime[1]).slice(-2)}</div>*/ }
					<h3>Upcoming Time</h3>
					{timeRows.slice(1)}
				</div>
			</div>

			<div className="FilterBox">
				<h2>Show rewards for</h2>
				{rewardTierFilters}
			</div>
			<div className="FilterBox FilterBox-IconFilters FilterBox-Sticky">
				{filters}
			</div>
			{ /*<div className="InfoBox"><div>
				<strong>Work in Progress</strong><br />
				Mission unlocks are accurate as of Infrastructure Log 8.
			</div></div>*/ }

			{currentJobSlug === 'critical' ? <div className="InfoBox"><div>Red alert variant can be determined by the speech bubbles of three NPCs in the base, just north of the aetheryte.</div></div> : null}

			{loading}

			<table className="MountTable">
				<tbody>
					{missionRows}
				</tbody>
			</table>
		</div>;
	}
}
